// RollingRangeWidget/RollingRangeCache.js
// Normal Cache — CacheBase2, singleton export (Engine Pattern rk=f03ae8b6).
// rk = "{sid}_{window}" (no date component!) — a re-fetch/re-push just overwrites the
// same entry in place. Unlike Sma200Cache (rk=896be0200668464897d0dc11b9ae1f47), this
// cache does NOT grow unbounded — max size is naturally sids x 4 windows, always.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'RollingRangeCache';

class RollingRangeCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }
}

const rollingRangeCache = new RollingRangeCache();
export default rollingRangeCache;
